#import "../fragments/webcast-fragment.graphql"

query GetUpcomingWebcasts($limit: Int, $type: String!) {
    upcomingWebcasts(limit: $limit, type: $type) {
        ...Webcast
    }
}
